import incogniaWebSdk from '@incognia/web-sdk'

import { type SdkAdapterInterface } from './sdk-adapter.interface'
import { type AppIdOrOptionsInit, type CustomEventParams, type GenerateRequestToken } from './types'

export class SdkAdapter implements SdkAdapterInterface {
  private _sdkWebInstance: typeof incogniaWebSdk

  constructor() {
    this._sdkWebInstance = incogniaWebSdk
  }

  async init(appIdOrOptions: string | AppIdOrOptionsInit): Promise<void> {
    await this._sdkWebInstance.init(appIdOrOptions)
  }

  async setAccountId(accountId: string): Promise<void> {
    await this._sdkWebInstance.setAccountId(accountId)
  }

  async clearAccountId(): Promise<void> {
    await this._sdkWebInstance.clearAccountId()
  }

  async generateRequestToken(options?: GenerateRequestToken): Promise<string | undefined> {
    return await this._sdkWebInstance.generateRequestToken(options)
  }

  async sendCustomEvent(paramsEvent: CustomEventParams): Promise<void> {
    await this._sdkWebInstance.sendCustomEvent(paramsEvent)
  }
}
